import { BCMSDate, BCMSStateManagerCRUD, useModel } from "@bcm-dev/bcms-vite";
import ChatPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/ChatPage";
import ChatItem from "components/pages/ChatPage/classes/ChatItem";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @function CaptureChatIcons
 * @return {React.Component}
 * @exported true
 * @description Capture component for "007_Chat_Icons".
 */
export default function CaptureChatIcons(props) {
    const { branding } = useModel();
    const options = branding.options || {};
    const chatVersion = options.chat_version_abi22 === "undefined" ? "Chat Box" : options.chat_version_abi22;

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(options))
        .update([ "showInitialMessage" ], false)
        .update([ "showTranslationPopup" ], false)
        .update([ "showFeaturePopup" ], true)
        .submit();

    const date = BCMSDate.init();
    const response = ChatItem.init("Hi, there! How can I help you?", "received", date, 0, "Agent")
    const question = ChatItem.init("Hi! I'm looking for my profile information.", "sent", date, 5)
    const responseTwo = ChatItem.init("No problem! Let me help you find that.", "received", date, 10, "Agent")

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "messages" ], [ response, question, responseTwo ])
        .submit();

    if(chatVersion === "Full Screen") {
        const message = `This capture is only shown when branding option "Chat Version" is set to "Chat Box".`;
        return <CaptureNotShownView message={ message }/>;
    }

    return <ChatPage ui={ ui } data={ data } />
}